<div class="flex h-full w-full flex-col items-center gap-2 px-[0.94rem]">
    @for(block of skeletonBlocks; track block.id) {
        <!-- Sidebar block kendo skeleton -->
        <div class="w-full rounded-lg p-2.5">
            <div class="flex flex-row">
                <div class="flex w-full flex-row gap-4 text-sidebar-icon/75">
                    <kendo-skeleton
                            shape="circle"
                            [animation]="disableAnimation ? false: 'wave'"
                            class="mt-0.5 size-6 min-w-[1.25rem] sm:size-5"
                    ></kendo-skeleton>

                    <kendo-skeleton
                            shape="text"
                            [animation]="disableAnimation ? false: 'wave'"
                            class="mr-4 w-full rounded-lg"
                    ></kendo-skeleton>
                </div>

            </div>
            <!-- Sidebar block inside links kendo skeleton -->
            @for(link of block.items; track link.id) {
                <div class="mt-2 flex max-h-64 flex-col overflow-hidden">
                    <div class="group my-1 ml-[2.27rem] flex cursor-pointer items-start whitespace-normal pr-4 text-xs text-sidebar-link/50 no-underline">
                        <kendo-skeleton
                                shape="circle"
                                [animation]="disableAnimation ? false: 'wave'"
                                class="mr-2.5 mt-0.5 size-3.5 min-w-3.5">
                            ></kendo-skeleton>

                        <kendo-skeleton
                                shape="text"
                                [animation]="disableAnimation ? false: 'wave'"
                                class="mr-5 w-full rounded-md">
                            ></kendo-skeleton>
                    </div>
                </div>
            }
        </div>
    }
</div>

